module.exports = __webpack_public_path__ + "img/91.18b622e8.jpg";